$(document).ready(function () {
  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");

    close_btns.each((index, close_btn) => {
      let parent_section = $(close_btn).closest(".section-announcement");

      $(close_btn).on("click", () => {
        parent_section.hide();
        document.documentElement.classList.add("announcement-hide");
        localStorage.setItem("announcement_bar_hidden", Date.now().toString());
      });
    });
  }
});

class AnnouncementRotator {
  constructor(el) {
    this.el = el;
    this.interval = parseInt(el.dataset.rotationInterval, 10) || 5000;
    this.items = Array.from(el.querySelectorAll(".announcement-bar__message-item"));
    if (this.items.length < 2) return;
    this.current = 0;
    this.paused = false;

    this.el.addEventListener("mouseenter", () => (this.paused = true));
    this.el.addEventListener("mouseleave", () => (this.paused = false));

    // Wire prev/next controls scoped to the same announcement bar
    const bar = el.closest(".announcement-bar") || el.parentElement;
    if (bar) {
      const prevBtn = bar.querySelector("[data-announcement-prev]");
      const nextBtn = bar.querySelector("[data-announcement-next]");
      if (prevBtn) prevBtn.addEventListener("click", () => this.goTo(this.current - 1));
      if (nextBtn) nextBtn.addEventListener("click", () => this.goTo(this.current + 1));
    }

    this.timer = window.setInterval(() => {
      if (this.paused) return;
      this.goTo(this.current + 1);
    }, this.interval);
  }

  goTo(nextIndex) {
    const total = this.items.length;
    const nextIdx = ((nextIndex % total) + total) % total;
    if (nextIdx === this.current) return;

    const currentEl = this.items[this.current];
    const nextEl = this.items[nextIdx];

    this.items.forEach((it) => {
      it.classList.remove("is-active", "is-leaving");
      it.setAttribute("aria-hidden", "true");
    });
    currentEl.classList.add("is-leaving");
    nextEl.classList.add("is-active");
    nextEl.setAttribute("aria-hidden", "false");

    this.current = nextIdx;
  }
}

function initAnnouncementRotators() {
  document
    .querySelectorAll("[data-announcement-rotator]")
    .forEach((el) => {
      if (!el.__rotatorInitialized) {
        new AnnouncementRotator(el);
        el.__rotatorInitialized = true;
      }
    });
}

document.addEventListener("DOMContentLoaded", initAnnouncementRotators);
document.addEventListener("shopify:section:load", initAnnouncementRotators);
